Ext.define('SA.NullPredicate', {
    extend: 'SA.AbstractPredicate',

    constructor() {
        this.hasNullType = true;
    },

    and(otherPredicate) {
        return otherPredicate;
    },

    serialize() {
        return null;
    }
});